import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { AsyncPaginate } from "react-select-async-paginate";
import moment from "moment";
import { ForeignData_API } from "../../../APIs/ForeignData.api";
import submitForm from "../../../services/submitForm";
import { error } from "jquery";
import FileImageUpdate from "../../../cpn/inputs/file-image-update";
import { Table } from "react-bootstrap";
import { components } from "react-select";
import { vi } from "date-fns/locale";
import { set } from "date-fns";

export default function CreateLenhDongBao() {
  const {
    lang,
    pages,
    proxy,
    functions,
    auth,
    page,
    database: { fields, tables },
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const { ct = [] } = auth;

  const auto =
    auth?.role === "pm" || auth?.role === "uad"
      ? true
      : ct.find((item) => item?.auto)?.auto || false;

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      optionLayViTri: "qrcode",
    },
  });
  const [isSubmit, setSubmit] = useState(false);
  const [defaultValues, setDefaultValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [isTables, setTables] = useState([]);
  const [options, setOptions] = useState({});
  const [refresh, setRefresh] = useState(0);
  const [isDisabled, setDisabled] = useState({
    quetQrcodeLayViTri: false,
    viTriBatDau: true,
    maLichRFID: true,
  });

  const [inputFields, setInputFields] = useState([
    {
      name: "Mã lệnh đóng bao",
      alias: "lenhDongBao",
      type: "select",
      required: true,
      table_id: "22587",
      displayFields: ["1MLĐB", "2SCSX", "7SL"],
      isPK: "1MLĐB",
    },
    {
      name: "Mã Thành Phẩm",
      alias: "maThanhPham",
      table_id: "21692",
      type: "select",
      required: true,
      displayFields: ["22MSP", "10TSP"],
      //   isApi: "/api/LDB/optionSPLDB",
      //   isParent: {
      //     alias: "lenhSanXuatLDB",
      //   },
      isPK: "22MSP",
    },
    {
      name: "Dây chuyền sản xuất",
      alias: "dayChuyenSanXuat",
      table_id: 4110611,
      type: "select",
      required: true,
      displayFields: ["IDLSX", "TenLSX"],
      isPK: "IDLSX",
    },
    {
      name: "",
      alias: "optionLayViTri",
      type: "option",
      options: [
        {
          label: "Quét QRCode",
          value: "qrcode",
          isChecked: true,
        },
        {
          label: "Nhập tay",
          value: "nhaptay",
        },
      ],
    },
    {
      name: "Quét Qrcode lấy vị trí",
      alias: "quetQrcodeLayViTri",
      type: "text",
      isButton: true,
      required: true,
      isNotCheckRequire: true,
      isApi: "/api/LDB/layViTri",
    },

    {
      name: "Mã lịch RFID",
      alias: "maLichRFID",
      type: "select",
      table_id: 21706,
      displayFields: ["1MLR"],
      isPK: "1MLR",
      required: true,
    },
    {
      name: "Vị trí bắt đầu",
      alias: "viTriBatDau",
      type: "text",
      required: true,
    },
    {
      name: "Vị trí kết thúc",
      alias: "viTriKetThuc",
      type: "text",
      required: true,
    },

    {
      name: "Ghi chú",
      alias: "ghiChu",
      type: "textarea",
    },
  ]);

  useEffect(() => {
    setInputFields((prev) =>
      prev.map((field) =>
        field.type !== "option"
          ? field
          : {
              ...field,
              options: field.options.map((opt) => ({
                ...opt,
                disabled: opt.value === "nhaptay" ? !auto : opt.disabled,
              })),
            }
      )
    );
  }, [auto]);

  // const handleCallApi = async () => {
  //   const _token = localStorage.getItem("_token");
  //   const param = getValues("quetQrcodeLayViTri");
  //   if (!param) {
  //     Swal.fire({
  //       icon: "warning",
  //       title: lang["warning"],
  //       text: "Vui lòng nhập mã Qrcode.",
  //     });
  //     return;
  //   }
  //   try {
  //     Swal.fire({
  //       title: "Đang lấy dữ liệu...",
  //       allowOutsideClick: false,
  //       didOpen: () => {
  //         Swal.showLoading();
  //       },
  //     });

  //     const { data, message } = await fetch(
  //       proxy() + `/api/LDB/layViTri/${param.trim()}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: _token,
  //           "content-type": "application/json",
  //           "data-amount": 100,
  //         },
  //       }
  //     ).then((res) => res.json());

  //     Swal.close();

  //     inputFields.forEach((item) => {
  //       if (data?.[item.alias]) {
  //         setValue(item.alias, data[item.alias]);
  //       }
  //     });

  //     if (!data) {
  //       Swal.fire({
  //         icon: "error",
  //         title: lang["fail"],
  //         text: message,
  //       });
  //     } else {
  //       Swal.fire({
  //         icon: "success",
  //         title: lang["success"],
  //         timer: 500,
  //         showConfirmButton: false,
  //       });
  //     }
  //   } catch (error) {
  //     Swal.close();
  //     Swal.fire({
  //       icon: "error",
  //       title: "Lỗi",
  //       text: "Không thể lấy dữ liệu từ máy chủ.",
  //     });
  //   }
  // };
  const changeQRCode = watch("quetQrcodeLayViTri");
  useEffect(() => {
    setValue("maLichRFID", "");
    setValue("viTriBatDau", "");
    setValue("viTriKetThuc", "");
  }, [changeQRCode]);

  const onSubmit = async (data, e) => {
    // e.preventDefault();
    const buttonName = e.nativeEvent.submitter.name;
    const { quetQrcodeLayViTri, maLichRFID } = data;
    const param = quetQrcodeLayViTri.split("/")?.pop();

    if (buttonName && maLichRFID) {
      const mappedData = {
        data,
        default_field_value: defaultValues,
        table: isTables,
      };

      const res = await submitForm({
        url: `/api/LSKH/GanThongTinSanPham`,
        data: mappedData,
        method: "PUT",
        proxy,
        lang,
        inputFields,
      });

      if (res) {
        inputFields.forEach((item) => {
          const { alias } = item;
          reset({
            [alias]: "",
            optionLayViTri: data?.optionLayViTri || "qrcode",
          });
        });
        // setRefresh(refresh + 1);
        setSelectedValues({});
      }
    } else {
      const _token = localStorage.getItem("_token");
      if (!param) {
        Swal.fire({
          icon: "warning",
          title: lang["warning"],
          text: "Vui lòng nhập mã Qrcode.",
        });
        return;
      }
      try {
        Swal.fire({
          title: "Đang lấy dữ liệu...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const { data, message } = await fetch(
          proxy() + `/api/LDB/layViTri/${param.trim()}`,
          {
            method: "GET",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
              "data-amount": 100,
            },
          }
        ).then((res) => res.json());

        Swal.close();

        inputFields.forEach((item) => {
          if (data?.[item.alias]) {
            if (item.type === "select") {
              const opt = {
                label: data?.[item.alias]?.label || data?.[item.alias],
                value: data?.[item.alias]?.value || data?.[item.alias],
              };
              setSelectedValues((prev) => ({
                ...prev,
                [item.alias]: opt,
              }));
              setValue(item.alias, data[item.alias]);
            }
            setValue(item.alias, data[item.alias]);
          }
        });

        if (!data) {
          Swal.fire({
            icon: "error",
            title: lang["fail"],
            text: message,
          });
        } else {
          Swal.fire({
            icon: "success",
            title: lang["success"],
            timer: 500,
            showConfirmButton: false,
          });
        }
      } catch (error) {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Lỗi",
          text: "Không thể lấy dữ liệu từ máy chủ.",
        });
      }
    }
  };

  return (
    <>
      <form className="midd_cont" onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row column_title">
            <div className="col-md-12">
              <div className="page_title">
                <h4 className="ml-1">Quản Lý Dữ Liệu</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="white_shd full margin_bottom_30 mb-0">
                <div className="full graph_head_cus d-flex">
                  <div className="heading1_cus margin_0 ">
                    <h5>
                      <label>
                        <a
                          className="pointer"
                          title={lang["back"]}
                          onClick={() => navigate(-1)}
                        >
                          <i className=" fa fa-chevron-circle-left mr-1 mt-3 mb-0 nav-item nav-link" />
                        </a>
                        {/* Lệnh Đóng Bao */}
                        {/* <i className="fa fa-chevron-right ml-2 mr-1" /> */}
                        Kích hoạt thông Tin Sản Phẩm
                      </label>
                    </h5>
                  </div>
                </div>
                <div className="table_section padding_infor_info input_put">
                  <div className="col-md-12 mt-4">
                    <div className="w-50 m-auto">
                      {inputFields.map((field, index) => {
                        const { required, name, isButton } = field;
                        return (
                          <div class="row">
                            <label
                              for={name}
                              className="col-sm-4 col-form-label font-weight-bold"
                            >
                              {name ? `${name}:` : ""}
                              {required && (
                                <span style={{ color: "red" }}>*</span>
                              )}
                            </label>
                            <div className="col-sm-8 mb-4 d-flex">
                              <div className="w-100">
                                <RenderInputs
                                  control={control}
                                  register={register}
                                  selectedValues={selectedValues}
                                  setSelectedValues={setSelectedValues}
                                  field={field}
                                  options={options}
                                  setValue={setValue}
                                  getValues={getValues}
                                  refresh={refresh}
                                  watch={watch}
                                  setDisabled={setDisabled}
                                  isDisabled={isDisabled}
                                />
                              </div>
                              {isButton && (
                                //   <div class="col-sm-1">
                                <button
                                  type="submit"
                                  className="btn btn-primary m-0 ml-2"
                                  // onClick={onSubmit}
                                  disabled={isDisabled?.[field?.alias]}
                                >
                                  Lấy vị trí
                                </button>
                                //   </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                      <div className="d-flex justify-content-end">
                        <button
                          type="submit"
                          className="btn btn-success mr-2"
                          style={{
                            minWidth: "105px",
                          }}
                          name="save"
                          onClick={() => setSubmit(true)}
                        >
                          Lưu lại
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger"
                          style={{
                            minWidth: "105px",
                          }}
                          onClick={() => navigate(-1)}
                        >
                          Đóng
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
function RenderInputs({
  field: f,
  options,
  selectedValues,
  setSelectedValues,
  control,
  register,
  setValue,
  getValues,
  isChild,
  refresh,
  dataSuggest,
  showDataSuggest,
  setShowDataSuggest,
  setDataSuggest,
  watch,
  setDisabled,
  isDisabled,
}) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const { filterData } = functions;
  const {
    type,
    alias,
    readOnly,
    table_id,
    displayFields,
    style,
    name,
    required,
    betChar,
    isPK,
    isMulti,
    isButton,
    isModal,
    isApi,
    isTable,
    isClone,
    isParent,
    isBased,
    options: optionsField,
  } = f;
  const value = getValues(alias);
  const valueParent = isParent && watch(isParent?.alias);

  const _token = localStorage.getItem("_token");
  const fetchDataChild = async (isApi, dataBody) => {
    return await fetch(proxy() + isApi, {
      method: "POST",
      headers: {
        Authorization: _token,
        "content-type": "application/json",
        "data-amount": 100,
      },
      body: JSON.stringify(dataBody),
    }).then((res) => res.json());
  };

  useEffect(() => {
    if (!valueParent && isParent) {
      setDisabled((prev) => ({
        ...prev,
        [alias]: true,
      }));
      setValue(alias, "");
      setSelectedValues((prev) => ({
        ...prev,
        [alias]: null,
      }));
      setValue("7SL", "");
      return;
    }

    if (isParent) {
      const fetchChildData = async () => {
        let dataBody = {
          table_id,
          start_index: 0,
          type: "or",
        };

        dataBody.LSX = valueParent;
        const { data } = await fetchDataChild(isApi, dataBody);

        if (!data.length) {
          setSelectedValues((prev) => ({
            ...prev,
            [alias]: null,
          }));
          setValue(alias, null);
          setDisabled((prev) => ({
            ...prev,
            [alias]: true,
          }));
        } else {
          const lotId = moment(data?.[0]?.["NSX"])
            .format("YYYY.MM")
            .replace(/\//g, "");

          setValue("7SL", lotId);

          setDisabled((prev) => ({
            ...prev,
            [alias]: false,
          }));
        }
      };

      fetchChildData();
    }
  }, [valueParent]);

  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  switch (type) {
    case "input-select":
      return (
        <div>
          {isChild && (
            <label
              class="form-label"
              style={{
                position: "absolute",
                top: "-27px",
                right: "-5px",
              }}
            >
              {name}
              {required && <span style={{ color: "red" }}>*</span>}
            </label>
          )}
          <select
            className="form-control"
            aria-label="Default select example"
            {...register(alias)}
            value={value}
            style={style}
            disabled={isDisabled?.[alias] || false}
          >
            <option></option>
            {options.length &&
              options.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
      );

    case "select":
      return (
        <Controller
          name={alias}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <>
              <div className="d-flex justify-content-between">
                <AsyncPaginate
                  key={isParent && valueParent}
                  className="mb-0 w-100"
                  {...field}
                  loadOptions={async (search, loadedOptions, { page }) => {
                    return await loadOptions(
                      page,
                      search,
                      displayFields,
                      table_id,
                      proxy,
                      isPK,
                      isApi,
                      isClone,
                      isParent,
                      valueParent,
                      setValue,
                      setSelectedValues,
                      alias
                    );
                  }}
                  value={selectedValues?.[alias] || null}
                  isDisabled={isDisabled?.[alias]}
                  onChange={(opt) => {
                    setDisabled((prev) => ({
                      ...prev,
                      ["maKyHieu"]: opt?.gradecontrolled ? false : true,
                    }));
                    if (opt?.defaultgrade) {
                      setValue("maKyHieu", opt?.defaultgrade);
                    }
                    if (isMulti || isModal?.id) {
                      setSelectedValues((prev) => {
                        const newPrev = { ...prev };
                        newPrev[alias] = opt.map((item) => ({
                          label: item?.label,
                          value: item?.value,
                          ...item,
                        }));
                        return newPrev;
                      });
                      if (isModal?.id) {
                        setDataSuggest((prev) => {
                          const newPrev = { ...prev };
                          newPrev["2LGH"] = opt;
                          return newPrev;
                        });
                        setShowDataSuggest(true);
                      }
                      setValue(
                        alias,
                        opt.map((item) => item?.value)
                      );
                    } else {
                      if (isBased) {
                        setValue(isBased?.name, opt?.[isBased?.alias]);
                      }
                      setValue(alias, opt?.value);

                      setSelectedValues((prev) => {
                        const newPrev = { ...prev };
                        newPrev[alias] = {
                          label: opt?.label,
                          value: opt?.value,
                        };
                        return newPrev;
                      });
                      if (dataSuggest) {
                        setDataSuggest((prev) => {
                          const newPrev = { ...prev };
                          newPrev["2LGH"] = [opt];
                          return newPrev;
                        });
                        setShowDataSuggest(true);
                      }
                    }
                  }}
                  additional={{ page: 0 }}
                  isSearchable={true}
                  allowCreateWhileLoading={false}
                  noOptionsMessage={() => (
                    <div style={{ fontWeight: "300" }}>
                      {lang["not found data"]}
                    </div>
                  )}
                  isClearable={true}
                  styles={{
                    menu: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  isMulti={isMulti}
                  closeMenuOnSelect={isMulti && false}
                  components={{
                    Option: isMulti ? CustomOption : components.Option,
                  }}
                  placeholder={lang["select value"]}
                />
              </div>
            </>
          )}
        />
      );

    case "textarea":
      return (
        <textarea
          rows={4}
          {...register(alias)}
          className="form-control"
          readOnly={readOnly}
        />
      );

    case "number":
      return Input(isDisabled, type, alias, register, readOnly, 0);
    case "float":
      return Input(
        isDisabled,
        type,
        alias,
        register,
        readOnly,
        0,
        "any",
        setValue
      );
    case "file":
      const files = getValues(alias);
      return (
        <FileImageUpdate
          key={refresh}
          field={alias}
          changeTrigger={(e, value) => {
            setValue(alias, value);
          }}
          defaultValue={files}
          isMultiple={true}
          col="col-sm-12"
          refresh={refresh}
          isCustom={true}
        />
      );
    case "option":
      return optionsField.map((item, index) => {
        return (
          <div key={index} className="form-check form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name={alias}
              disabled={item?.disabled || false}
              id={`${alias}-${index}`}
              value={item.value}
              {...register(alias)}
              checked={value === item.value}
              defaultChecked={item.isChecked}
              onClick={(e) => {
                setValue("maLichRFID", "");
                setValue("viTriBatDau", "");
                setValue("viTriKetThuc", "");
                setSelectedValues((prev) => ({
                  ...prev,
                  maLichRFID: "",
                }));
                const state = item?.value === "qrcode";
                setDisabled((prev) => ({
                  ...prev,
                  quetQrcodeLayViTri: !state,
                  viTriBatDau: state,
                  maLichRFID: state,
                }));
              }}
            />
            <label className="form-check-label" htmlFor={`${alias}-${index}`}>
              {item.label}
            </label>
          </div>
        );
      });
    case "text":
    default:
      return Input(isDisabled, type, alias, register, readOnly);
  }
}

const loadOptions = async (
  page = 0,
  search = "",
  displayFields,
  table_id,
  proxy,
  isPK,
  isApi,
  isClone,
  isParent,
  valueParent,
  setValue,
  setSelectedValues,
  alias
) => {
  return new Promise(async (resolve, reject) => {
    let dataBody = {
      table_id,
      start_index: page,
      type: "or",
    };

    let newData = {
      options: [],
      hasMore: false,
      additional: {
        page: 0,
      },
    };
    if (search) {
      let criteria = {};
      let criteria_type = {};
      displayFields.forEach((field) => {
        criteria[field] = search.trim();
        criteria_type[field] = "regex";
      });

      dataBody.criteria = criteria;
      dataBody.criteria_type = criteria_type;
    }
    dataBody.LSX = valueParent;

    const _token = localStorage.getItem("_token");
    try {
      const { data } = isApi
        ? await fetch(proxy() + isApi, {
            method: "POST",
            headers: {
              Authorization: _token,
              "content-type": "application/json",
              "data-amount": 100,
            },
            body: JSON.stringify(dataBody),
          }).then((res) => res.json())
        : await ForeignData_API.get(proxy(), _token, dataBody);
      let hasMoreValue = true;

      if (!data?.length) {
        hasMoreValue = false;
      }

      if (data.length) {
        const options = data.flatMap((item) => {
          const hasArrayField = displayFields.find((field) =>
            Array.isArray(item[field])
          );

          if (!hasArrayField) {
            return item?.[isPK]
              ? [
                  {
                    label: displayFields
                      .map((field) => item[field])
                      .filter(Boolean)
                      .join("|"),
                    value: item?.[isPK],
                    ...item,
                  },
                ]
              : [];
          }

          const arrayField = hasArrayField;
          const arrayValues = item[arrayField];

          return !isClone
            ? [
                {
                  label: displayFields
                    .map((field) => item[field])
                    .filter(Boolean)
                    .join("|"),
                  value: item?.[isPK],
                  ...item,
                },
              ]
            : arrayValues.map((val) => {
                const clonedItem = { ...item, [arrayField]: val };
                return {
                  label: displayFields
                    .map((field) => clonedItem[field])
                    .filter(Boolean)
                    .join("|"),
                  value: clonedItem?.[isPK],
                  ...clonedItem,
                };
              });
        });

        newData = {
          options,
          hasMore: hasMoreValue,
          additional: {
            page: hasMoreValue ? page + 15 : page,
          },
        };
      }

      setTimeout(() => {
        resolve(newData);
      }, 100);
    } catch (error) {
      console.error("Error in loadOptions:", error);
      reject(error);
    }
  });
};

const Input = (
  isDisabled,
  type,
  alias,
  register,
  readOnly,
  min,
  step,
  setValue
) => {
  return (
    <input
      {...register(alias, { valueAsNumber: type === "number" })}
      type={type === "float" ? "number" : type}
      className="form-control"
      // readOnly={readOnly}
      min={min}
      step={step}
      onBlur={(e) => {
        const { value } = e.target;
        if (type === "float" && value) {
          const roundedValue = parseFloat(value).toFixed(3);
          const parseValue = Number(roundedValue);
          setValue(alias, parseValue);
        }
      }}
      disabled={isDisabled?.[alias] || false}
      // max="999"
      // maxLength="3"
    />
  );
};
